// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwTextarea from 'viewmodel/AwTextareaViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "data": {
    "submitRfqQuoteSideNavRightData": {
      "slide": "PUSH",
      "direction": "RIGHT_TO_LEFT",
      "animation": false,
      "width": "WIDE",
      "height": "FULL"
    },
    "comments": {
      "displayName": "Comments",
      "type": "STRING",
      "isRequired": "false",
      "isEditable": "true",
      "requiredText": "Please enter comments here",
      "numberOfLines": 5
    }
  },
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    },
    "rfqquoteid": {
      "type": "string"
    }
  },
  "actions": {
    "submitRfqQuote": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "mutation submitRfqQuote( $collaborationspaceId: String, $rfqQuoteId: String, $comments: String) { submitRfqQuote( collaborationspaceId: $collaborationspaceId, rfqQuoteId: $rfqQuoteId, comments: $comments) }",
            "variables": {
              "collaborationspaceId": "{{ctx.rfq.collaborationspaceid || props.collaborationspaceid}}",
              "rfqQuoteId": "{{ctx.rfq.rfqquoteid || props.rfqquoteid}}",
              "comments": "{{data.comments.dbValue}}"
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{ctx.rfq.accsessionid || props.accsessionid}}"
      },
      "outputData": {
        "response": "data.data.submitRfqQuote",
        "errorCode": "errorCode"
      },
      "events": {
        "success": [{
          "condition": "response.error === undefined",
          "name": "submit-rfq-quote.success",
          "eventData": {
            "response": "{{response}}"
          }
        }, {
          "condition": "response.error === 'EMPTY_COLLAB_SPACE'",
          "name": "submit-rfq-quote.error",
          "eventData": {
            "error": "{{i18n.EMPTY_COLLAB_SPACE}}",
            "errorCode": 400
          }
        }, {
          "condition": "response.error.statusCode === 400 || errorCode === 400",
          "name": "submit-rfq-quote.error",
          "eventData": {
            "error": "{{response.error}}"
          }
        }, {
          "condition": "response.error.statusCode === 403 || errorCode === 403",
          "name": "submit-rfq-quote.error",
          "eventData": {
            "error": "{{i18n.FORBIDDEN}}",
            "errorCode": 403
          }
        }, {
          "condition": "response.error.statusCode === 401 || errorCode === 401 || errorCode === 'INVALID_ACC_SESSION_ID'",
          "name": "submit-rfq-quote.error",
          "eventData": {
            "error": "{{i18n.UNAUTHORIZED}}",
            "errorCode": 401
          }
        }, {
          "condition": "response.error.statusCode >= 500 && response.error.statusCode <= 599",
          "name": "submit-rfq-quote.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }],
        "failure": [{
          "name": "submit-rfq-quote.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }]
      },
      "deps": "js/accHttpService"
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventId}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/accEventBus"
    }
  },
  "onEvent": [{
    "eventId": "submit-rfq-quote.success",
    "message": "SubmitRfqQuoteSuccess"
  }, {
    "eventId": "submit-rfq-quote.success",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-submit-rfq-quote.success",
      "eventData": "{{eventData.response}}"
    }
  }, {
    "eventId": "submit-rfq-quote.error",
    "message": "SubmitRfqQuoteError"
  }, {
    "eventId": "submit-rfq-quote.error",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-submit-rfq-quote.error",
      "eventData": {
        "message": "{{eventData.error}}",
        "statusCode": "{{eventData.errorCode}}"
      }
    }
  }],
  "conditions": {},
  "messages": {
    "SubmitRfqQuoteSuccess": {
      "messageType": "INFO",
      "messageText": "RFQ Quote submitted successfully."
    },
    "SubmitRfqQuoteError": {
      "messageType": "WARNING",
      "messageText": "Error occured in Submit Rfq Quote"
    }
  },
  "i18n": {
    "Submit": ["RfqMessages"],
    "ACC_SERVER_ERROR": ["errorMessages"],
    "EMPTY_COLLAB_SPACE": ["errorMessages"],
    "FORBIDDEN": ["errorMessages"],
    "UNAUTHORIZED": ["errorMessages"]
  },
  "_viewModelId": "SubmitRfqQuote",
  "_uniqueViewModelId": "SubmitRfqQuote",
  "ctx": {
    "rfq": {
      "type": "object"
    }
  }
};

/*
<div class="afx-content-background aw-layout-full sw-column">
    <table>
        <tr class="tableBody">
            <td>
                <aw-textarea prop="data.comments"></aw-textarea>
            </td>
            </tr>
            <tr class="tableFooter">
                <td>
                    <aw-button action="submitRfqQuote" size="auto">{{i18n.Submit}}</aw-button>
                </td>
            </tr>
    </table>
</div>

*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement("div", {
    className: "afx-content-background aw-layout-full sw-column"
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", {
    className: "tableBody"
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(AwTextarea, getField("data.comments", fields, $index, null, null)))), /*#__PURE__*/React.createElement("tr", {
    className: "tableFooter"
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(AwButton, {
    action: actions.submitRfqQuote,
    size: "auto"
  }, AwParseService.instance("i18n.Submit")({
    props,
    data,
    fields,
    dataProviders,
    ctx,
    i18n,
    actions,
    subPanelContext,
    viewPath,
    conditions,
    formProp,
    dispatch,
    selectionModels,
    editHandlers,
    chartProviders,
    ports
  })))))));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;